<div class="d-flex flex-column gap-1">
  @if (content.useAccessibleCalculator) {
    @if (showDoubleMeter && !content.smartMeterCheckboxShownAsRadioButtons) {
      <crnt-checkbox>
        <input
          type="checkbox"
          [id]="controls?.doubleMeter?.id"
          [ngrxFormControlState]="controls?.doubleMeter"
          wlAutomationId="smart-meter-checkbox"
        />
        <label slot="label" [for]="controls?.doubleMeter?.id">{{
          content.doubleMeterCheckboxLabel
        }}</label>
      </crnt-checkbox>
    }
    <crnt-checkbox>
      <input
        type="checkbox"
        [id]="controls?.hasSolarPanel?.id"
        [ngrxFormControlState]="controls?.hasSolarPanel"
      />
      <label slot="label" [for]="controls?.hasSolarPanel?.id">{{
        content.solarPanelCheckboxLabel
      }}</label>
    </crnt-checkbox>
  } @else {
    @if (showDoubleMeter && !content.smartMeterCheckboxShownAsRadioButtons) {
      <wl-checkbox
        [formsControl]="controls?.doubleMeter"
        [label]="content.doubleMeterCheckboxLabel ?? ''"
        [rendering]="rendering"
        [showValidation]="false"
        [tooltip]="content.doubleMeterCheckboxTooltip"
        fieldName="dubbele meter"
        stepName="invullen"
        wlAutomationId="smart-meter-checkbox"
      />
    }
    <wl-checkbox
      [formsControl]="controls?.hasSolarPanel"
      [label]="content.solarPanelCheckboxLabel ?? ''"
      [rendering]="rendering"
      [showValidation]="false"
      [tooltip]="
        !content.estimationToolIsShown
          ? content.solarPanelCheckboxTooltip
          : undefined
      "
      fieldName="zonnepanelen"
      stepName="invullen"
    />
  }
</div>
